import { render, staticRenderFns } from "./FailedPaymentPopup.vue?vue&type=template&id=0d810fbe&scoped=true"
import script from "./FailedPaymentPopup.vue?vue&type=script&lang=js"
export * from "./FailedPaymentPopup.vue?vue&type=script&lang=js"
import style0 from "./FailedPaymentPopup.vue?vue&type=style&index=0&id=0d810fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d810fbe",
  null
  
)

export default component.exports